import { render, staticRenderFns } from "./GdprModal.vue?vue&type=template&id=505de238&"
import script from "./GdprModal.vue?vue&type=script&lang=js&"
export * from "./GdprModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports